import { lazy } from "react";
import Loadable from "app/components/Loadable";

const RamList = Loadable(lazy(() => import("./RamList")));
const RamAdd = Loadable(lazy(() => import("./RamAdd")));

const RamRoutes = [
  { path: "/asset/ram", element: <RamList /> },
  { path: "/asset/ram/:mode/:id", element: <RamAdd /> },
];

export default RamRoutes;
